/* global $ */
import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';

export class ImageUploadContainer extends Component {
    constructor(props) {
        super(props);

        var adImage = this.props.fieldValues.adImage;
        if (adImage === "undefined" || adImage === null || adImage.length === 0) {
            this.props.setImagePreviewContainerDisplay("none");
            this.props.setImageUploadFormContainer("block");
            this.props.setImageUploaded(false);
        } else {
            this.props.setImagePreviewContainerDisplay("block");
            this.props.setImageUploadFormContainer("none");
            this.props.setImageUploaded(true);
        }

        this.deleteImagePreview = this.deleteImagePreview.bind(this);
    }

    uploadFile() {
        // uploading image
        if ($("#uploadImageForm input:file").val() !== "") {
            $("#uploadImageForm").submit();
        }
    };

    selectFile() {
        $('#uploadFile').click();
    }

    deleteImagePreview() {
        this.props.fieldValues.adImage = null;
        this.props.setImagePreviewContainerDisplay("none");
        this.props.setImageUploadFormContainer("block");
        this.props.setImageUploaded(false);

        $('#uploadFile').val('');
    }

    render() {
        return (
            <div id="imageUploadContainer">
                <div className="field"
                     id="imagePreviewContainer"
                     style={{display: this.props.imagePreviewContainerDisplay}}>
                    <img id="imagePreviewImg" src={this.props.fieldValues.adImage} /><br />
                    <Button type="button"
                            className="btn secondary"
                            onClick={this.deleteImagePreview.bind(this)}>{this.props.showMessage('message_22_01')}</Button>
                </div>
                <div id="imageUploadFormContainer"
                     style={{display: this.props.imageUploadFormContainer}}>
                    <p>{this.props.showMessage('message_7_12')}</p>
                    <div id="imageUploadFormOuterContainer">
                        <form id="uploadImageForm">
                            <Button type="button" className="btn secondary" onClick={this.selectFile}>{this.props.showMessage('message_22_02')}</Button>
                            <input id="uploadFile" type="file" name="uploadedFile" style={{display: 'none'}} onChange={this.uploadFile}/>
                        </form>
                    </div>
                </div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ImageUploadContainer.jsx